import { API, Storage } from "aws-amplify";
import { findByOwner } from "@/helpers";
import * as mutations from "@/graphql/mutations";
import * as queries from "@/graphql/queries";
import initUser from "@/assets/user.json";
export default {
  namespaced: true,
  state: {
    users: [],
  },
  getters: {
    user: (state) => {
      return (id) => {
        const user = findByOwner(state.users, id);
        if (!user) return null;
        return {
          ...user,
          // TODO  埋める
          // get materials() {
          //   return rootState.materials.items.filter(
          //     (material) => material.owner === user.owner
          //   );
          // }
        };
      };
    },
  },
  actions: {
    async getUsers({ commit }) {
      const results = await API.graphql({
        query: queries.listUsers,
      });
      // get latest profile image url
      const items = results.data.listUsers.items;
      items.forEach(async (item) => {
        if (item.profileImage) {
          item.profileImage.url = await Storage.get(item.profileImage.key);
        }
      });
      commit("setUsers", results.data.listUsers.items);
    },
    async createUser({ dispatch, rootState }) {
      if (!rootState.auth.authUser) return;
      console.log(initUser);
      const data = {
        name: initUser.data.username,
        owner: rootState.auth.authUser.username,
      };
      await API.graphql({
        query: mutations.createUser,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      //STATEの更新
      dispatch("getUsers");
    },
    async updateUser({ dispatch, getters, rootState }, { form }) {
      const data = {
        // id: this.user.id,
        id: getters.user(rootState.auth.authUser.username).id,
        ...form,
      };
      await API.graphql({
        query: mutations.updateUser,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      //STATEの更新
      dispatch("getUsers");
      const message = "保存しました";
      dispatch("utils/openSnackbar", message, { root: true });
    },
    //使ってない
    async deleteUser({ dispatch }, { id }) {
      const data = {
        id: id,
      };
      await API.graphql({
        query: mutations.deleteUser,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      //STATEの更新
      dispatch("getUsers");
      const message = "削除しました";
      dispatch("utils/openSnackbar", message, { root: true });
    },
  },
  mutations: {
    setUsers(state, user) {
      state.users = user;
    },
  },
};
